<template>
  <el-dialog
    :visible.sync="Visible"
    title="单据同步处理中"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="canClose"
    append-to-body
  >
    <div class="el-dialog__body">
      <div class="el-steps el-steps--horizontal">
        <!---->
        <div class="el-step is-horizontal" style="flex-basis: 50%; margin-right: 0px;">
          <div class="el-step__head is-process" v-if="step1 == 1">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-loading"></i>
              <!---->
              <div class="el-step__main">
                <div class="el-step__title is-process">基础信息校验</div>
                <div class="el-step__description is-process">共{{step1num}}条数据，校验中</div>
              </div>
            </div>
          </div>
          <div class="el-step__head is-finish" v-if="step1 == 2">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-check"></i>
              <!---->
              <div class="el-step__main">
                <div class="el-step__title is-finish">基础信息校验</div>
                <div class="el-step__description is-finish">已校验成功</div>
              </div>
            </div>
          </div>
          <div class="el-step__head is-error" v-if="step1 == 3">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: 0ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-close"></i>
              <!---->
              <div class="el-step__main">
                <div class="el-step__title is-error">基础信息校验</div>
                <div class="el-step__description is-error">基础信息校验失败</div>
              </div>
            </div>
          </div>
        </div>
        <!---->
        <!---->
        <div class="el-step is-horizontal" style="flex-basis: 50%; margin-right: 0px;">
          <div class="el-step__head is-wait" v-if="step2 == 0">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-text">
              <!-- <i class="el-step__icon-inner el-icon-phone-outline"></i> -->
              <div class="el-el-step__icon-inner">2</div>
              <!---->
            </div>
            <div class="el-step__main">
              <div class="el-step__title is-wait">单据同步</div>
              <!-- <div class="el-step__description is-wait">共三条数据，处理中</div> -->
            </div>
          </div>
          <div class="el-step__head is-process" v-if="step2 == 1">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-loading"></i>
              <div class="el-step__main">
                <div class="el-step__title is-process">单据同步</div>
                <div class="el-step__description is-process">共{{step2num}}条数据，处理中</div>
              </div>
            </div>
          </div>
          <div class="el-step__head is-finish" v-if="step2 == 2">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-check"></i>
              <div class="el-step__main">
                <div class="el-step__title is-finish">单据同步</div>
                <div class="el-step__description is-finish">已同步单据</div>
              </div>
            </div>
          </div>
          <div class="el-step__head is-error" v-if="step2 == 3">
            <div class="el-step__line" style="margin-right: 0px;">
              <i
                class="el-step__line-inner"
                style="transition-delay: -150ms; border-width: 0px; width: 0%;"
              ></i>
            </div>
            <div class="el-step__icon is-icon">
              <i class="el-step__icon-inner el-icon-close"></i>
              <div class="el-step__main">
                <div class="el-step__title is-error">单据同步</div>
                <div class="el-step__description is-error">单据同步失败</div>
              </div>
            </div>
          </div>
        </div>
        <!---->
        <div class="el-step is-horizontal" style="flex-basis: 20%; ">
          <div class="el-step__head is-wait" v-if="step3  == 0">
            <div class="el-step__line">
              <i class="el-step__line-inner"></i>
            </div>
            <div class="el-step__icon is-text">
              <div class="el-el-step__icon-inner">3</div>
            </div>
            <div class="el-step__main">
              <div class="el-step__title is-wait">完成</div>
            </div>
          </div>
          <div class="el-step__head is-finish" v-if="step3 == 2">
            <div class="el-step__line">
              <i class="el-step__line-inner"></i>
            </div>
            <div class="el-step__icon is-icon">
              <!---->
              <i class="el-step__icon-inner el-icon-check"></i>
              <div class="el-step__main">
                <div class="el-step__title is-finish">完成</div>
                <div class="el-step__description is-finish">complete</div>
              </div>
            </div>
          </div>
        </div>
        <!---->
      </div>
    </div>
    <div class="errormsg" v-if="step1errormsg.length>0">
      基础信息校验失败信息：
      <el-button @click="exportExcel" size="mini" class="floatright" type="primary">点击导出</el-button>
      <el-table
        :data="step1errormsg"
        size="mini"
        border
        :highlight-current-row="true"
        class="toggletable"
        ref="detail"
        id="out-table"
      >
        <el-table-column type="index" label="序号" width="50" fixed></el-table-column>
        <el-table-column label="错误项" prop="basicName" min-width="80" fixed></el-table-column>
        <el-table-column label="错误项名称" prop="name" min-width="80" fixed></el-table-column>
        <el-table-column label="错误项编码" prop="code" min-width="80" fixed></el-table-column>
      </el-table>
    </div>
    <div class="errormsg" v-if="step2errormsg != ''">
      单据同步失败信息：
      {{ step2errormsg}}
    </div>
  </el-dialog>
</template>
  
<script>
import config from "../../common/config";
import FileSaver from "file-saver";
import XLSX from "xlsx";
export default {
  data() {
    return {
      Visible: false,
      step1: 2, // 1 process  2 finish  3 error
      step2: 1, // 0 wait  1 process  2 finish  3 error
      step3: 0, // 0 wait  2 finish
      activestep: 1, //0 step1  1 step2  3 finish
      step1num: 0,
      step2num: 0,
      step1errormsg: [],
      step2errormsg: "",
      canClose: false
    };
  },

  methods: {
    beginStep(step1num) {
      this.step1num = step1num;
      this.step1 = 1;
      this.step2 = 0;
      this.step3 = 0;
      this.activestep = 0;
      this.step1errormsg = "";
      this.step2errormsg = "";
      this.canClose = false;
      this.Visible = true;
    },
    failstep1(errormsg) {
      this.step1 = 3;
      this.step1errormsg = errormsg;
      this.canClose = true;
    },
    failstep2(errormsg) {
      this.step2 = 3;
      this.step2errormsg = errormsg;
      this.canClose = true;
    },
    successstep1(step2num) {
      this.step2num = step2num;
      this.step1 = 2;
      this.step2 = 1;
      this.activestep = 1;
      this.canClose = false;
    },
    successstep2() {
      this.step2 = 2;
      this.step3 = 2;
      this.activestep = 3;
      this.canClose = true;
    },
    changeCanClose() {
      this.canClose = true;
    },
    exportExcel() {
      /* 从表生成工作簿对象 */
      let fix = document.querySelector(".el-table__fixed");
      let wb;
      var xlsxParam = { raw: true };
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#out-table").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#out-table").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#out-table"),
          xlsxParam
        );
      }
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "基础信息校验失败信息.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    }
  }
};
</script>
  
<style>
.myshowup.el-button {
  border-radius: 16px;
}
.el-append-search {
  background-color: #409eff !important;
  color: #fff !important;
}
.graybg {
  background: #f9f9f9 !important;
}
.is-finish .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 26px;
  font-weight: 600;
  border: solid 2px #409eff;
  border-radius: 36px;
  padding: 4px;
  margin-right: 6px;
}

.is-process .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 32px;
  font-weight: 800;
  margin-right: 8px;
  color: #409eff;
}

.is-wait .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 32px;
  margin-right: 8px;
}

.is-error .el-step__icon-inner[class*="el-icon"]:not(.is-status) {
  font-size: 26px;
  font-weight: 600;
  border: solid 2px #f56c6c;
  border-radius: 36px;
  padding: 4px;
  margin-right: 6px;
}
.el-step_number_text {
  font-size: 26px;
  border: solid 2px #c0c4cc;
  border-radius: 36px;
  padding: 4px;
  margin-right: 6px;
}

.el-step__head .is-finish .el-step__line {
  color: #409eff;
}

.is-finish .el-step__icon.is-icon {
  width: 200px;
}

.is-process .el-step__icon.is-icon {
  width: 200px;
}
.is-wait .el-step__icon.is-icon {
  width: 200px;
}

.is-error .el-step__icon.is-icon {
  width: 200px;
}

.is-wait .el-step__icon.is-text {
  float: left;
  margin-left: 20px;
  margin-right: 6px;
}
.is-wait .el-step__main {
  float: left;
}

.is-wait .el-step__line {
  left: 150px !important;
}
.el-step__title.is-process {
  color: #409eff !important;
}
.is-finish .el-step__line {
  background-color: #409eff;
}
.el-step__title .is-finish {
  font-weight: 600;
}

.el-step__description {
  padding-right: 0;
}
.el-step__icon {
  width: 36px;
  height: 36px;
}
.errormsg {
  padding: 20px 40px;
  color: #f56c6c;
}
.floatright {
  float: right;
}
</style>
